import { useState, useEffect } from 'react';

/**
 * Custom hook for managing checklist timer
 * Handles start time, elapsed time calculation, and timer updates
 * Note: This hook manages timer state only (no localStorage usage)
 */
export const useChecklistTimer = (isOpen, startTime) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let interval;
    if (isOpen && startTime) {
      const startDate = startTime instanceof Date ? startTime : new Date(startTime);
      
      // Set initial elapsed time
      setElapsedTime(Math.floor((new Date() - startDate) / 1000));
      
      // Update every second
      interval = setInterval(() => {
        setElapsedTime(Math.floor((new Date() - startDate) / 1000));
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isOpen, startTime]);

  // Format elapsed time as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return { elapsedTime, formatTime };
};